import React from 'react'

function Button(props) {
	return (
		<div className={`ButtonComponent ${props.className}`} style={props.style}>
			<button
				type={props.type}
				style={props.btnStyle}
				//className="btn"
				className={`btn ${props.className}`}
				onClick={props.onClick}
				disabled={props.disabled}
			>
				{props.label}
				{props.children}
			</button>
		</div>
	)
}
/** How To Call Button Inside Page **/
/** <Button variant="outlined" label="Hello" className="btn1" /> **/

export default Button
